import { TFunction } from 'react-i18next'

export interface Form {
    dropdown1?: number | string
    dropdown2?: number | string
    dropdown3?: number | string
}

export const validate = async (values: Form, t: TFunction<'translation'>) => {
    const errors: Partial<Form> = {}
    if (!values.dropdown1) {
        errors.dropdown1 = `${t('LABEL.SELECT_REQUIRED')}` as any
    }
    return errors
}

const useDropdown = () => {
    const data = [
        {
            id: 0,
            name: 'None',
        },
        {
            id: 1,
            name: 'Button',
        },
        {
            id: 2,
            name: 'Loading',
        },
    ]

    const handleSubmit = (values: any) => {
        console.log('submit', values)
    }

    return {
        onSubmit: handleSubmit,
        dataList: data,
    }
}

export default useDropdown
